(function () {
  var accordion =  document.querySelectorAll('.js-main-accordion')
  if(accordion.length == 0) return false

  for(var i = 0; i < accordion.length; i++) {
    setAccordion(accordion[i])
  }

  function setAccordion(target) {
    var trigger = target.querySelector('.js-main-accordion-trigger')

    trigger.addEventListener('click', showContents)
    var container = target.querySelector('.js-main-accordion-container')
    var contents= target.querySelector('.js-main-accordion-contents')

    if(target.classList.contains('is-pc-show')) {
      window.addEventListener('load', windowLoaded)
    }

    function windowLoaded() {
      if (window.matchMedia('(min-width: 768px)').matches) {
        showContents()
      }
      window.removeEventListener('load', windowLoaded)
    }

    function showContents() {
      trigger.classList.add('is-show')
      container.classList.add('is-show')
      setContentsHeight()
      window.addEventListener('resize', resize)

      trigger.removeEventListener('click', showContents)
      trigger.addEventListener('click', hideContents)
    }

    function hideContents() {
      trigger.classList.remove('is-show')
      container.classList.remove('is-show')
      container.style.height = ''
      window.removeEventListener('resize', resize)

      trigger.removeEventListener('click', hideContents)
      trigger.addEventListener('click', showContents)
    }

    function setContentsHeight() {
      container.style.height = ''
      var contentsH = contents.scrollHeight
      container.style.height = contentsH + 'px'
    }

    var currentWidth
    function resize() {
      if (currentWidth == window.innerWidth) {
        return
      }
      setContentsHeight()
      currentWidth = window.innerWidth
    }
  }
  
}());